import React from "react";
import { Alert, Button, Badge } from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";

const EmployeeNotifications = ({ approvedTokens, pendingCount, dueTodayCount, onOpenOrder }) => {
    if (!approvedTokens?.length && !pendingCount && !dueTodayCount) {
        return null;
    }

    return (
        <div className="mb-4">
            {/* Approved Edit Tokens Ready to Edit */}
            {approvedTokens && approvedTokens.length > 0 && (
                <Alert color="success" className="d-flex flex-wrap justify-content-between align-items-center shadow-sm py-2 px-3 mb-2" style={{ borderRadius: "8px" }}>
                    <div className="d-flex align-items-center">
                        <i className="mdi mdi-check-decagram text-success font-size-22 me-2"></i>
                        <div>
                            <strong>Edit Permission Granted!</strong>
                            <div className="font-size-13 text-muted">
                                Admin approved your request to edit {approvedTokens.length} document(s). You have <strong>one-time edit authorization</strong>.
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap gap-2 mt-2 mt-md-0">
                        {approvedTokens.map((item) => (
                            <Button
                                key={item.id}
                                color="success"
                                size="sm"
                                className="fw-semibold text-nowrap"
                                onClick={() => {
                                    if (item.document_type === "order" && onOpenOrder) {
                                        onOpenOrder(item);
                                    } else {
                                        window.location.href = item.document_type === "order" ? "/orders" : "/invoices";
                                    }
                                }}
                            >
                                <i className="mdi mdi-pencil-circle me-1"></i>
                                Edit {item.document_type?.toUpperCase()} #{item.document_number || item.document_id}
                            </Button>
                        ))}
                    </div>
                </Alert>
            )}

            {/* Pending Requests Alert */}
            {pendingCount > 0 && (
                <Alert color="warning" className="d-flex justify-content-between align-items-center shadow-sm py-2 px-3 mb-2" style={{ borderRadius: "8px" }}>
                    <div className="d-flex align-items-center">
                        <i className="mdi mdi-clock-alert-outline text-warning font-size-22 me-2"></i>
                        <div>
                            <strong>Pending Approvals ({pendingCount}):</strong>
                            <span className="font-size-13 text-muted ms-1">
                                You have {pendingCount} edit request(s) awaiting Admin authorization.
                            </span>
                        </div>
                    </div>
                    <Badge color="warning" className="px-2 py-1">In Review</Badge>
                </Alert>
            )}

            {/* Due Today Alert */}
            {dueTodayCount > 0 && (
                <Alert color="danger" className="d-flex justify-content-between align-items-center shadow-sm py-2 px-3 mb-0" style={{ borderRadius: "8px" }}>
                    <div className="d-flex align-items-center">
                        <i className="mdi mdi-alert-circle-outline text-danger font-size-22 me-2"></i>
                        <div>
                            <strong>Urgent Delivery Target:</strong>
                            <span className="font-size-13 text-muted ms-1">
                                {dueTodayCount} order(s) are scheduled for dispatch/completion today.
                            </span>
                        </div>
                    </div>
                    <Link to="/orders" className="btn btn-outline-danger btn-sm py-1 fw-semibold">
                        View Orders <i className="mdi mdi-arrow-right ms-1"></i>
                    </Link>
                </Alert>
            )}
        </div>
    );
};

export default EmployeeNotifications;
